import { ApisServices } from 'src/app/models/enums/apis-services';

export class ApisError {
    public apiService: ApisServices;
    public error: string;
    constructor(data?: any) {
        this.error = data && data.error ? data.error : '';
        this.apiService = data && data.apiService ? data.apiService : null;
    }
 }